import type { Scenario } from "@/domain/entities";
import { useApp } from "../container";
import { useQuery } from "../hooks/useQuery";
import { useLocale } from "../i18n/LocaleProvider";
import { scenarioTintStyle } from "../theme/scenarioTint";
import { Button } from "./Button";
import styles from "./ScenarioPicker.module.css";

const DEFAULT_TIME = "21:00";

/** Card listing the scenarios the user has not subscribed to yet; renders nothing once all are taken. */
export function ScenarioPicker() {
  const app = useApp();
  const { t, pick } = useLocale();
  const available = useQuery<Scenario[]>(async () => {
    const [subscriptions, scenarios] = await Promise.all([app.store.subscriptions.listAll(), app.store.scenarios.list()]);
    return scenarios.filter((s) => !subscriptions.some((sub) => sub.scenarioId === s.id));
  }, [], app.changeSources);
  if (!available.data?.length) return null;
  return (
    <div className={styles.card}>
      <span className={styles.label}>{t.settings.addScenario}</span>
      <div className={styles.actions}>
        {available.data.map((scenario) => (
          <Button key={scenario.id} style={scenarioTintStyle(scenario)} onClick={() => { app.analytics.track("scenario_added", { scenarioId: scenario.slug }); void app.subscriptions.subscribe(scenario, DEFAULT_TIME); }}>
            {pick(scenario.name)}
          </Button>
        ))}
      </div>
    </div>
  );
}
